/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Info_SectionInputs */

const vi_care_log_info_section = /** @type {(inputs: Care_Log_Info_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin nhật ký`)
};

/**

* @param {Care_Log_Info_SectionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_info_section = /** @type {((inputs?: Care_Log_Info_SectionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Info_SectionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_info_section(inputs)
});